import React, {useContext, useState} from 'react';
import logo from '../assets/logo.png'
import {Link, Navigate, useNavigate} from "react-router";
import AuthContext from "../context/AuthProvider";
import axios from "axios";
import {toast} from "react-toastify";
import {BiLoader} from "react-icons/bi";
function Giris() {
    const {auth, setAuth} = useContext(AuthContext);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [entering, setEntering] = useState(false);
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setEntering(true)
        try {
            const res = await axios.post("https://clerksoftware.com/audiotime.php", {
                password,email
            }, {
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if(res.data.success){
                setAuth(email)
                localStorage.setItem("AudioTimeAuth",email)
                navigate('/dummy');
                if(email === "nesine@audiotime.com.tr"){
                    navigate('/nesine', { replace: true })
                }else if(email === "demo@audiotime.com.tr"){
                    navigate('/demo', { replace: true });
                }
                else if(email === "castroledge@audiotime.com.tr"){
                    navigate('/castrol-edge', { replace: true });
                }
                else if(email === "dyson@audiotime.com.tr"){
                    navigate('/dyson', { replace: true });
                }
                else if(email === "shark@audiotime.com.tr"){
                    navigate('/shark', { replace: true });
                }
                else if(email === "lassa@audiotime.com.tr"){
                    navigate('/lassa', { replace: true });
                }
                else if(email === "petlas@audiotime.com.tr"){
                    navigate('/petlas', { replace: true });
                }
                else if(email === "kocakgold@audiotime.com.tr"){
                    navigate('/kocak-gold', { replace: true });
                }
                else if(email === "aygaz@audiotime.com.tr"){
                    navigate('/aygaz', { replace: true });
                }
                else if(email === "cocacola@audiotime.com.tr"){
                    navigate('/cocacola', { replace: true });
                }
                else if(email === "axess@audiotime.com.tr"){
                    navigate('/axess', { replace: true });
                }
                return null;

            }else{
                setAuth("0")
                toast.error("Girdiğiniz şifre veya email yanlış!")
                localStorage.removeItem("AudioTimeAuth")
            }
            setEntering(false)

        } catch (err) {
            console.error("API hatası:", err);
            setEntering(false)
        }
    };

    if (auth === "demo@audiotime.com.tr") {
        navigate('/dummy');
        navigate('/demo', { replace: true });
        return null
    }

    if (auth === "nesine@audiotime.com.tr") {
        navigate('/dummy');
        navigate('/nesine', { replace: true });
        return null
    }

    if (auth === "hepsiburada@audiotime.com.tr") {
        navigate('/hepsiburada', { replace: true });
        return null
    }

    return (
        <section className="account">
            <div className="account__bid">
                <img src="assets/images/thumb/account-bid.png" alt=""/>
            </div>
            <Link to="/" className="account-close" reloadDocument>
                <i className="las la-times"/>
            </Link>
            <div className="account-left">
                <div className="account-left__logo">
                    <Link to={"/"} className="account-left__logo-link" >
                        {" "}
                        <img src={logo} alt=""/>
                    </Link>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <form action="#" autoComplete="off">
                                <h2 className="account-title text-uppercase">
                                    YAPAY ZEKA DEMO GİRİŞ
                                </h2>
                                <div className="row gy-4">

                                    <div className="col-sm-12">
                                        <input
                                            type="email"
                                            className="form--control"
                                            placeholder="Email Address"
                                            onChange={e => setEmail(e.target.value)}
                                            value={email}
                                        />
                                    </div>
                                    <div className="col-sm-12">
                                        <input
                                            type="password"
                                            className="form--control"
                                            placeholder="Şifre"
                                            onChange={e => setPassword(e.target.value)}
                                            value={password}
                                        />
                                    </div>

                                    <div className="col-sm-12">
                                        <p className="contact-content__desc">Demo girişi için kullanıcı bilgileri almak istiyorsanız, <Link style={{color:"#7e2a82"}} to="/iletisime-gecin" reloadDocument>iletişime geçin</Link></p>
                                    </div>
                                    <div className="col-sm-12">
                                        <button type="submit" className="btn--base style-two" onClick={handleSubmit}>
                                            {entering ? <BiLoader className="rotating"/> : "GİRİŞ"}
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="account-right">
                <div className="account-right__thumb">
                    <img src="assets/images/thumb/account-man-img.png" alt=""/>
                </div>
            </div>
        </section>

    );
}

export default Giris;